/** @jsx h */
import { h } from 'preact'

const TickIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='14'
    viewBox='0 0 14 14'
  >
    <g
      fill='none'
      fillRule='evenodd'
      stroke='#2f3a4a'
      transform='translate(1 1)'
    >
      <circle cx='6' cy='6' r='6' />
      <path strokeLinecap='round' d='M3 6l2 2 4-4' />
    </g>
  </svg>
)

export default TickIcon
